import React, { useEffect } from "react";
import { IoClose } from "react-icons/io5";

/**
 * Lightweight modal shell used across Lead Management.
 * Handles overlay, Esc-to-close and body scroll locking.
 */
const LeadModal = ({
  isOpen,
  onClose,
  title,
  subtitle,
  headerExtra,
  footer,
  size = "md",
  accentColor,
  disableClose = false,
  children,
}) => {
  useEffect(() => {
    if (!isOpen) return undefined;

    const handleKeyDown = (e) => {
      if (e.key === "Escape" && !disableClose) onClose();
    };

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, onClose, disableClose]);

  if (!isOpen) return null;

  return (
    <div className="lm-modal-wrapper" role="dialog" aria-modal="true">
      <div className="lm-modal-overlay" onClick={disableClose ? undefined : onClose} />

      <div
        className={`lm-modal lm-modal--${size}`}
        style={accentColor ? { "--lm-accent": accentColor } : undefined}
      >
        <div className={`lm-modal-header ${accentColor ? "lm-modal-header--accent" : ""}`}>
          <div className="lm-modal-heading">
            {typeof title === "string" ? <h4>{title}</h4> : title}
            {subtitle && <p>{subtitle}</p>}
          </div>

          <div className="lm-modal-header-actions">
            {headerExtra}
            <button
              type="button"
              className="lm-icon-btn"
              onClick={onClose}
              disabled={disableClose}
              aria-label="Close"
            >
              <IoClose size={20} />
            </button>
          </div>
        </div>

        <div className="lm-modal-body">{children}</div>

        {footer && <div className="lm-modal-footer">{footer}</div>}
      </div>
    </div>
  );
};

export default LeadModal;
